import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/field/$fieldId/$")({
    beforeLoad: ({ location }) => {
        throw redirect({
            to: location.pathname
                .replace(/^\/dashboard\/field\//i, "/dashboard/fields/")
                .replace(
                    /^(\/dashboard\/fields\/[^/]+\/insights)\/?$/i,
                    "$1/ntime",
                ),
            search: location.search,
            hash: location.hash,
            replace: true,
        });
    },
});
